import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Helper function to capitalize the first letter of each word
// Toast configuration
export const toastConfig = {
  position: "top-right",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
};

// Success toast (keep capitalization for success)
const capitalizeMessage = (message) => {
  if (typeof message !== "string" || !message.trim()) {
    return message || "";
  }
  return message
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const showSuccess = (message) => {
  toast.success(capitalizeMessage(message), {
    ...toastConfig,
    icon: "✅",
  });
};

// Error toast - RAW backend messages (NO capitalization)
export const showError = (message) => {
  if (message) {
    toast.error(message, {
      ...toastConfig,
      icon: "❌",
    });
  }
};

// Warning toast
export const showWarning = (message) => {
  toast.warn(capitalizeMessage(message), {
    ...toastConfig,
    icon: "⚠️",
  });
};

// Info toast
export const showInfo = (message) => {
  toast.info(capitalizeMessage(message), {
    ...toastConfig,
    icon: "ℹ️",
  });
};

// Promise toast - for async operations
export const showPromise = (promise, messages) => {
  toast.promise(
    promise,
    {
      pending: messages.pending || "Processing...",
      success: messages.success || "Success!",
      error: messages.error || "Error occurred!",
    },
    toastConfig,
  );
};

export default toast;
